export const contactUsMessages = {
	submitSuccessDescription: {
		id: 'contactSubmitSuccessDescription',
		defaultMessage: 'You should hear back from us within a few business days.',
	},
	submitSuccessTitle: {
		id: 'contactSubmitSuccessTitle',
		defaultMessage: 'Thanks for reaching out!',
	},
	buttonLabel: {
		id: 'contactButtonLabel',
		defaultMessage: 'Send message',
	},
};
